import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { TrendingUp, Users, DollarSign, Star } from 'lucide-react';

const StatsSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  const stats = [
    {
      icon: <Users size={32} />,
      value: "100+",
      label: "Active Users",
      description: "Spa professionals worldwide"
    },
    {
      icon: <TrendingUp size={32} />,
      value: "40%",
      label: "Average Revenue Increase",
      description: "Within first 3 months"
    },
    {
      icon: <DollarSign size={32} />,
      value: "₹2.5M+",
      label: "Revenue Generated",
      description: "For our customers monthly"
    },
    {
      icon: <Star size={32} />,
      value: "4.9/5",
      label: "Customer Rating",
      description: "Based on 500+ reviews"
    }
  ];

  return (
    <section className="section-padding bg-gradient-to-br from-slate-50 to-slate-200 relative overflow-hidden" ref={ref}>
      <div className="absolute inset-0 opacity-5">
        <div 
          className="absolute inset-0"
          style={{
            backgroundImage: `
              radial-gradient(circle at 20% 20%, rgba(99, 102, 241, 0.1) 0%, transparent 50%),
              radial-gradient(circle at 80% 80%, rgba(139, 92, 246, 0.1) 0%, transparent 50%)
            `,
            backgroundSize: '600px 600px'
          }}
        ></div>
      </div>
      <div className="container relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 0.6 }}
        >
          <div className="text-center mb-16">
            <h2 className="text-large text-gradient mb-4">
              Trusted by Spa Professionals Worldwide
            </h2>
            <p className="text-small text-gray-600 max-w-2xl mx-auto">
              Join thousands of successful spa businesses that have transformed their operations with Wellness Pro.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <motion.div
                key={index}
                className="bg-white rounded-2xl p-8 text-center shadow-card border border-gray-200 relative overflow-hidden hover:shadow-card-hover hover:-translate-y-2 transition-all duration-300"
                initial={{ opacity: 0, y: 30 }}
                animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
              >
                <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-primary-500 to-secondary-500"></div>
                <div className="w-20 h-20 bg-gradient-to-r from-primary-500 to-secondary-500 rounded-2xl flex items-center justify-center mx-auto mb-6 text-white shadow-lg shadow-primary-500/30">
                  {stat.icon}
                </div>
                <div className="text-gray-900">
                  <div className="text-4xl font-extrabold text-gray-900 mb-2 leading-none bg-gradient-to-r from-primary-500 to-secondary-500 bg-clip-text text-transparent">{stat.value}</div>
                  <div className="text-lg font-semibold text-gray-700 mb-2">{stat.label}</div>
                  <div className="text-sm text-gray-500 leading-relaxed">{stat.description}</div>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default StatsSection;
